/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Demands_OpenInputs */

const cs_demands_open = /** @type {(inputs: Demands_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Otevřít poptávku`)
};

const en_demands_open = /** @type {(inputs: Demands_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open demand`)
};

/**
* | output |
* | --- |
* | "Open demand" |
*
* @param {Demands_OpenInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const demands_open = /** @type {((inputs?: Demands_OpenInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Demands_OpenInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_demands_open(inputs)
	return cs_demands_open(inputs)
});